import axios from "axios";
import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Page";
import ProjectsHeader from "./Header/index";
import { Spin } from "antd";
import Tab from "./Tab/index";
import { LoadingContainer } from "./styled.components";
import { BACKEND_URL } from "../../constants/urls";
const Projects = () => {
  const [projectData, setProjectData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const getProject = async () => {
    setIsLoading(true);
    const response = await axios.get(`${BACKEND_URL}/projects`);
    setProjectData(response.data.projects);
    setIsLoading(false);
  };

  useEffect(() => {
    getProject();
  }, []);
  useEffect(() => {}, [projectData]);

  return (
    <Layout>
      <ProjectsHeader />
      {isLoading ? (
        <LoadingContainer>
          <Spin />
        </LoadingContainer>
      ) : (
        <Tab projects={projectData} />
      )}
    </Layout>
  );
};

export default Projects;
